import useMediaQuery from '@mui/material/useMediaQuery';
export const useIsTouchDevice = ()=>useMediaQuery('(hover: none), (pointer: coarse)');

//# sourceMappingURL=useIsTouchDevice.js.map